import { supabase } from '../utils/supabaseClient';
const check = ({ data, error }) => { if (error) throw new Error(error.message); return data; };
export async function getRacingProjects(companyId) {
  return check(await supabase.from('projects').select('id,name,created_at').eq('company_id', companyId).contains('spec_json', { workspace: 'racing' }).order('name'));
}
export async function createRacingProject(companyId, name) {
  const user = check(await supabase.auth.getUser()).user;
  if (!user) throw new Error('Please sign in again.');
  return check(await supabase.from('projects').insert({ name: name.trim(), company_id: companyId, created_by: user.id, spec_json: { workspace: 'racing' } }).select('id,name,created_at').single());
}
export async function getRacingSessions(companyId, projectId) {
  let query = supabase.from('racing_sessions').select('*').eq('company_id', companyId).order('survey_date', { ascending: false });
  if (projectId) query = query.eq('project_id', projectId);
  return check(await query);
}
export async function getRacingSession(companyId, sessionId) {
  return check(await supabase.from('racing_sessions').select('*, project:projects(name)').eq('company_id', companyId).eq('id', sessionId).single());
}
export async function downloadAcf(path) { return check(await supabase.storage.from('racing-files').download(path)); }
export async function saveRacingSession({ companyId, projectId, name, date, file, metadata }) {
  const user = check(await supabase.auth.getUser()).user;
  if (!user) throw new Error('Please sign in again.');
  const id = crypto.randomUUID();
  const path = `${companyId}/${id}/source.acf`;
  check(await supabase.storage.from('racing-files').upload(path, file, { contentType: 'application/octet-stream', upsert: false }));
  try {
    return check(await supabase.from('racing_sessions').insert({ id, company_id: companyId, project_id: projectId, name: name.trim(), survey_date: date, filename: file.name, storage_path: path, uploaded_by: user.id, metadata }).select().single());
  } catch (error) {
    const cleanup = await supabase.storage.from('racing-files').remove([path]);
    if (cleanup.error) throw new Error(`${error.message} The original file could not be cleaned up; contact support before retrying.`);
    throw error;
  }
}
